import { render, staticRenderFns } from "./proHome.vue?vue&type=template&id=60085d2a&scoped=true&"
import script from "./proHome.vue?vue&type=script&lang=js&"
export * from "./proHome.vue?vue&type=script&lang=js&"
import style0 from "./proHome.vue?vue&type=style&index=0&id=60085d2a&scoped=true&lang=css&"
import style1 from "./proHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60085d2a",
  null
  
)

export default component.exports